import { motion } from 'framer-motion';

interface RatingProps {
  rating: number; // The current rating value
  maxRating?: number; // Maximum possible rating (default is 5)
  className?: string; // Additional CSS classes for customization
  filledStarClass?: string; // CSS class for filled stars
  emptyStarClass?: string; // CSS class for empty stars
}

const Rating: React.FC<RatingProps> = ({
  rating,
  maxRating = 5,
  className = '',
  filledStarClass = 'text-accent fill-current',
  emptyStarClass = 'text-gray-300',
}) => {
  const starVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: (i: number) => ({
      scale: 1,
      opacity: 1,
      transition: {
        delay: i * 0.1, // Stagger animation based on star index
        type: 'spring',
        stiffness: 300,
      },
    }),
  };

  return (
    <div className={`flex ${className}`}>
      {[...Array(maxRating)].map((_, i) => (
        <motion.svg
          className={`w-5 h-5 ${i < rating ? filledStarClass : emptyStarClass}`}
          variants={starVariants}
          key={i}
          custom={i}
          initial="hidden"
          animate="visible"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
        </motion.svg>
      ))}
    </div>
  );
};

export default Rating;
